export function paymentsAnalytics(state = [], action) {
  switch (action.type) {
    case "PAYMENTS_ANALYTICS_FETCH_DATA_SUCCESS":
      return action.paymentsAnalytics;
    default:
      return state;
  }
}
